// Shared stale-time constants for React Query hooks.
// Always 0 in non-production so UAT / dev always sees fresh data.
// In production, use short windows for frequently-changing aggregates.

const isProd = import.meta.env.VITE_APP_STAGE === "production";

// Dashboard summary cards — refetch every 2 min in prod; always fresh in non-prod.
export const SUMMARY_STALE_TIME = isProd ? 1000 * 60 * 2 : 0;
